import { render } from "./index.vue?vue&type=template&id=773bdfa6&scoped=true"
import script from "./script.js?vue&type=script&lang=js"
export * from "./script.js?vue&type=script&lang=js"

import "./style.less?vue&type=style&index=0&id=773bdfa6&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-773bdfa6"

export default script